import { createClient } from "@supabase/supabase-js";

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY;

// NOTE about Hostinger + prerender:
// - Hostinger builds your Vite app in Node.
// - vite-prerender-plugin executes the built bundle in Node to prerender routes.
// If we throw at import-time when env vars are missing, the build fails before you can even redeploy.
// We therefore only throw in the browser runtime.
if ((!SUPABASE_URL || !SUPABASE_ANON_KEY) && typeof window !== "undefined") {
  // This app is deployed as a static build; values must be provided at build-time (Vite env vars).
  throw new Error(
    "Supabase env vars missing: set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY"
  );
}

export const supabase =
  SUPABASE_URL && SUPABASE_ANON_KEY
    ? createClient(SUPABASE_URL, SUPABASE_ANON_KEY)
    : null;
